<form [formGroup]="form" class="gender_multiselect">
  <div class="row justify-content-center">
    <div class="table-responsive">
      <table class="table quote-table">
        <thead>
          <th>&nbsp;</th>
          <th>{{ data.clickBalance ? 'CLICKS' : 'COMPLETES' }}</th>
          <th class="min-max-width">
            <span>MIN</span>
          </th>
          <th class="min-max-width">
            <span>MAX</span>
          </th>
        </thead>
        <tbody
          *ngIf="data.qualification.data.length"
          formArrayName="quotas"
          class="add-input-fields"
        >
          <tr
            *ngFor="let quotaForm of quotas.controls; let i = index"
            [formGroupName]="i"
          >
            <td *ngIf="quotaForm.value.selected">
              <a
                class="chain-left"
                *ngIf="
                  quotaForm.value.selectedForGroup &&
                  data.qualification.qualification_code !==
                    zipcodeQualificationCode
                "
                (click)="ungroupQuota(quotaForm.value)"
                ><i class="fa fa-chain-broken"></i
              ></a>
              {{ quotaForm.value.text }}
            </td>
            <td *ngIf="quotaForm.value.selected">
              <input
                type="text"
                class="form-control border-0 border-bottom text-center rounded-0"
                formControlName="number"
                (keyup)="numberChange($event, i)"
                psUiInputRestriction="[0-9]"
              />
              <input
                type="text"
                class="form-control border-0 border-bottom text-center rounded-0 mx-2"
                maxlength="3"
                formControlName="percentage"
                (keyup)="percentageChange($event, i)"
                psUiInputRestriction="[0-9]"
              />
              <span>%</span>
            </td>
            <td *ngIf="quotaForm.value.selected">
              <input
                type="text"
                class="form-control border-0 border-bottom text-center rounded-0"
                formControlName="minimum"
                [attr.readonly]="true"
                psUiInputRestriction="[0-9]"
              />
            </td>
            <td *ngIf="quotaForm.value.selected">
              <input
                type="text"
                class="form-control border-0 border-bottom text-center rounded-0"
                maxlength="3"
                formControlName="maximum"
                [attr.readonly]="true"
                psUiInputRestriction="[0-9]"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</form>
